export const kindRatingPage = {
    kindRatingPageAddPetButtonDesktop: {
        rbmail: {
            type: 'click',
            id: '42708002',
        },
    },
    kindRatingPageAddPetButtonTouch: {
        rbmail: {
            type: 'click',
            id: '42708029',
        },
    },
    kindRatingPageSecondaryActionButtonDesktop: {
        rbmail: {
            type: 'click',
            id: '42708004',
        },
    },
    kindRatingPageSecondaryActionButtonTouch: {
        rbmail: {
            type: 'click',
            id: '42708030',
        },
    },
};
